import { defineStore } from 'pinia'
import type { ShipmentQuoteForm } from '@/types/shipment'
import { DEFAULT_FORM } from '@/types/shipment'

export const useShipmentStore = defineStore('shipment', {
  state: () => ({
    currentStep: 1,
    quoteForm: { ...DEFAULT_FORM },
  }),

  actions: {
    setStep(step: number) {
      this.currentStep = step
    },

    updateQuoteForm(form: ShipmentQuoteForm) {
      this.quoteForm = form
    },

    clearForm() {
      this.quoteForm = { ...DEFAULT_FORM }
      // localStorage.removeItem('quote-form')
    },
  },
})
